export default "__VITE_ASSET__Dw2TMtls__"